<template>
  <div class="project-materials" v-if="project">
    <div class="accordion" role="tablist">
      <!-- Orders Block -->
      <AccessBlock :id="PROJECT_ORDERS_BLOCK">
        <div class="mb-3">
          <b-button
            block
            v-b-toggle.materials-new-orders
            variant="outline-primary"
            class="text-left accordion-header"
          >
            <i class="fa fa-shopping-cart mr-2"></i>{{ $t('orders') }}
            <i class="fa fa-chevron-down float-right mt-1"></i>
          </b-button>
          <b-collapse id="materials-new-orders" role="tabpanel" visible>
            <div class="accordion-content px-2 py-2">
              <ProjectOrders :project="project" />
            </div>
          </b-collapse>
        </div>
      </AccessBlock>

      <!-- Orders Section: no block, shown only in Legacy-Authz (see feature page materialwirtschaft) -->
      <div v-if="!isOrganizationRoleNavigationEnabled" class="mb-3">
        <b-button
          block
          v-b-toggle.materials-orders
          variant="outline-primary"
          class="text-left accordion-header"
        >
          <i class="fa fa-list mr-2"></i>{{ $t('orders') }} (alt)
          <i class="fa fa-chevron-down float-right mt-1"></i>
        </b-button>
        <b-collapse id="materials-orders" role="tabpanel">
          <div class="accordion-content px-2 py-2">
            <!-- Order Status Fields -->
            <ProjectOrderSettings :project="project" />

            <!-- Item Selection and Project Items -->
            <b-row>
              <b-col lg="6" md="6" sm="12" v-if="project.items">
                <ItemSelect
                  v-on:item-select:add-item="onAddItemToProject"
                  v-on:item-select:remove-item="onRemoveItemFromProject"
                />
              </b-col>
              <b-col lg="6" md="6" sm="12">
                <ProjectItems
                  :items="items"
                  v-on:item-select:remove-all-items="onRemoveAllItemsFromProject"
                  :project="project"
                />
              </b-col>
            </b-row>
          </div>
        </b-collapse>
      </div>

      <!-- Inventory Section -->
      <AccessBlock :id="PROJECT_ITEM_INVENTORY_BLOCK">
        <div class="mb-3">
          <b-button
            block
            v-b-toggle.materials-inventory
            variant="outline-primary"
            class="text-left accordion-header"
          >
            <i class="fa fa-cubes mr-2"></i>{{ $t('inventory') }}
            <i class="fa fa-chevron-down float-right mt-1"></i>
          </b-button>
          <b-collapse id="materials-inventory" role="tabpanel">
            <div class="accordion-content px-2 py-2">
              <ProjectItemInventory :project="project" />
            </div>
          </b-collapse>
        </div>
      </AccessBlock>

      <!-- Consumed Items Section -->
      <AccessBlock :id="PROJECT_CONSUMED_ITEMS_BLOCK">
        <div class="mb-3">
          <b-button
            block
            v-b-toggle.materials-consumed
            variant="outline-primary"
            class="text-left accordion-header"
          >
            <i class="fa fa-rocket mr-2"></i>{{ $t('consumed_items') }}
            <i class="fa fa-chevron-down float-right mt-1"></i>
          </b-button>
          <b-collapse id="materials-consumed" role="tabpanel">
            <div class="accordion-content px-2 py-2">
              <ProjectConsumedItems :project="project" />
            </div>
          </b-collapse>
        </div>
      </AccessBlock>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import AccessBlock from '@/components/Access/AccessBlock.vue';
import ProjectConsumedItems from '@/blocks/project/ProjectConsumedItems.vue';
import ProjectItemInventory from '@/blocks/project/ProjectItemInventory.vue';
import ProjectOrders from '@/blocks/project/ProjectOrders.vue';
import {
  PROJECT_CONSUMED_ITEMS_BLOCK,
  PROJECT_ITEM_INVENTORY_BLOCK,
  PROJECT_ORDERS_BLOCK,
} from '@/navigation/accessNodes';
import ProjectItems from './ProjectItems';
import ItemSelect from './ItemSelect';
import ProjectOrderSettings from './ProjectOrderSettings';

export default {
  name: 'ProjectMaterials',
  components: {
    AccessBlock,
    ProjectItems,
    ItemSelect,
    ProjectOrderSettings,
    ProjectItemInventory,
    ProjectConsumedItems,
    ProjectOrders,
  },
  props: {
    project: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      PROJECT_ITEM_INVENTORY_BLOCK,
      PROJECT_CONSUMED_ITEMS_BLOCK,
      PROJECT_ORDERS_BLOCK,
    };
  },
  computed: {
    ...mapGetters('auth', ['isOrganizationRoleNavigationEnabled']),
    items() {
      return this.project.items;
      //   const itemTypes = ['STANDARD', 'AC', 'DC'];
      // return this.project.items
      //   ? this.project.items.filter((item) => itemTypes.includes(item.item.type))
      //   : [];
    },
  },
  methods: {
    /** */
    onAddItemToProject(itemData) {
      console.log('onAddItemToProject()', parseInt(itemData.addRemoveCount), itemData);
      const addRemoveCount = parseInt(itemData.addRemoveCount);
      const item = this.project.items.find((item) => item.item._id == itemData._id);
      if (item) {
        item.count += addRemoveCount;
      } else {
        const newItem = {
          count: addRemoveCount,
          item: itemData,
        };
        this.project.items.push(newItem);
      }
    },

    /** */
    onRemoveItemFromProject(itemData) {
      const addRemoveCount = parseInt(itemData.addRemoveCount);
      const item = this.project.items.find((item) => item.item._id == itemData._id);
      if (item) {
        item.count -= addRemoveCount;
        if (item.count <= 0) {
          const index = this.project.items.findIndex((item) => item.item._id == itemData._id);
          // console.log(index);
          this.project.items.splice(index, 1);
        }
      }
    },

    async onRemoveAllItemsFromProject() {
      this.project.items = [];
    },
  },
};
</script>

<style scoped lang="scss">
// Legacy legend styles (kept for reference)
legend {
  font-size: 1.1rem;
  font-weight: 600;
  color: #495057;
  margin-bottom: 1rem;

  i {
    color: #6c757d;
  }
}
</style>
